import React from "react";
import '../sections/SloganSection.css';

function SloganSection() {

    return (
        <>
            {/* <section class="promotion clearfix"></section> */}

            <section className="lema">
                <div className="word">
                    <p className="frase"></p>
                </div>
                <br />
            </section>
        </>
    );
}

export default SloganSection;